module.exports = __webpack_public_path__ + "img/icon-ecosystem-gray.918a22cf.svg";